module.exports = __webpack_public_path__ + "img/loader.19d70c1b.png";